import SVG from 'react-inlinesvg';
import styled from 'styled-components';
import { ty } from '@client/styles/typography';

export const DisclaimerText = styled.p.attrs({
  className: ty('paragraph400', 'secondary'),
})`
  text-align: center;
`;

export const LockIcon = styled(SVG)`
  display: inline-block;
  flex-shrink: 0;
  height: 16px;
  width: 16px;
  color: var(--foreground-primary);
`;

export const LockSpacer = styled.div`
  display: grid;
  grid-template-columns: auto 16px auto;
  grid-column-gap: 16px;
  align-items: center;
  :before,
  :after {
    background-color: var(--border-primary);
    content: '';
    display: inline-block;
    height: 1px;
    position: relative;
    vertical-align: middle;
  }
`;

export const DisclaimerStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
